import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import { usePlayer } from "../../../contexts/PlayerContext";
import VideoPlayer from "./VideoPlayer/VideoPlayer";
import Navigation from "./Navigation/Navigation";
import Recordings from "./Recordings/Recordings";

import "./LiveStreamEmbed.css";

const LiveStreamEmbed = ({ stream }) => {
        const { backgroundImage, setStreamId, setSlug, setBackgroundImage } = usePlayer();
        const [activeTab, setActiveTab] = useState("live");
        const [background, setBackground] = useState("");

        useEffect(() => {
            if (backgroundImage) {
                console.log("Background image updated:", backgroundImage);
                setBackground(backgroundImage);
            }
        }, [backgroundImage, background]);
    
    useEffect(() => {
        if (stream) {
            console.log("Stream data updated:", stream);
            setStreamId(stream.metadata.stream_camera_id);
            setSlug(stream.slug);
            setBackground(
                `https://churchcamlive.ie/assets/images/background-images/${stream.slug}.webp`
            );
        }
    }, [stream, setStreamId, setSlug, setBackgroundImage]);

    return (
        <Container className="py-0 py-md-5 my-0 my-md-5">
            <div
                className="player-container rounded d-flex justify-content-center align-items-center"
                style={{
                    marginTop: "25px",
                    marginBottom: "25px",
                    position: "relative",
                    width: "100%",
                    height: 0,
                    flexDirection: "column",
                    paddingBottom: "56.25%",
                    overflowY: "hidden",
                    boxShadow:
                        "rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px",
                    backgroundImage: background ? `url(${background})` : "",
                    backgroundSize: "cover",
                    backgroundColor: "#000", // Fallback background color
                }}
            >
                <Navigation activeTab={activeTab} setActiveTab={setActiveTab} />
                {activeTab === "live" && <VideoPlayer />}
                {activeTab === "recordings" && <Recordings />}
            </div>
        </Container>
    );
};

export default LiveStreamEmbed;
